<template>
  <v-dialog
    v-model="dialog"
    class="ch-dialog"
    max-width="800"
  >
    <div class="ch-dialog-card">
      <v-toolbar class="ch-dialog-toolbar" :height="45">
        <v-toolbar-title>
          <i class="fas fa-calendar-alt fa-fw"></i>
          <span class="title">NEW BOOKING</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <button @click="closeDialog" class="close-btn">
          <i class="fas fa-window-close fa-fw"></i>
        </button>
      </v-toolbar>
      <div class="ch-dialog-body">
        <v-form v-model="valid" ref="form">
          <v-layout row wrap>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">EMAIL *</div>
                <div class="form-input">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    full-width
                  ></v-text-field>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">HOTEL *</div>
                <div class="form-input">
                  <v-select
                    :items="hotelItems"
                    v-model="getHotelName"
                    item-text="name"
                    item-value="id"
                    full-width
                    bottom
                    single-line
                    @focus.native="getHotelList"
                    @click.native="getHotelList"
                    autocomplete
                    :rules="hotelRules"
                    content-class="create-autocomplete-select"
                  ></v-select>
                </div>
              </div>
              <div class="form-group" v-if="hotel !== null">
                <div class="form-title">ROOM TYPE *</div>
                <div class="form-input">
                  <v-select
                    :items="roomtypeItems"
                    v-model="getRoomtype"
                    item-text="name"
                    item-value="id"
                    @click.native="getRoomtypeList"
                    :rules="roomTypeRules"
                    full-width
                  ></v-select>
                </div>
              </div>
            </v-flex>
            <v-flex xs6 class="pl-3 pr-3">
              <div class="form-group">
                <div class="form-title">CHECKIN AT *</div>
                <div class="form-input">
                  <v-dialog
                    persistent
                    v-model="checkinModal"
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="checkin_at"
                      :rules="checkinRules"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="checkin_at" scrollable actions>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click.native="cancel">Cancel</v-btn>
                          <v-btn flat color="primary" @click.native="save">OK</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
              <div class="form-group">
                <div class="form-title">CHECKOUT AT *</div>
                <div class="form-input">
                  <v-dialog
                    persistent
                    v-model="checkoutModal"
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="checkout_at"
                      :rules="checkoutRules"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="checkout_at" scrollable actions>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn flat color="primary" @click.native="cancel">Cancel</v-btn>
                          <v-btn flat color="primary" @click.native="save">OK</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="ch-dialog-footer">
        <button
          :class="{ save: valid }"
          :disabled="!valid"
          @click="createBooking"
        >
          <i class="fas fa-save fa-fw"></i>
          <span>SAVE</span>
        </button>
        <button
          class="cancel"
          @click="closeDialog"
        >
          <i class="fas fa-times-circle fa-fw"></i>
          <span>CANCEL</span>
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
  import { bookingsEventBus } from '@/components/admin/bookings/bookingsEventBus';
  import api from '../../../api';

  export default {
    data() {
      return {
        dialog: false,
        valid: true,
        userListItems: [],
        user_id: null,
        email: null,
        hotelItems: [],
        hotel: null,
        roomtypeItems: [],
        roomtype: null,
        // NOTE: Date picker
        checkin_at: null,
        checkinModal: false,
        checkout_at: null,
        checkoutModal: false,
        emailRules: [
          v => (v === 0) || !!v || 'Please input Email',
          /* eslint max-len: ["error", { "code": 200 }] */
          v => /^\w+([\\.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
        ],
        hotelRules: [
          v => (v === 0) || !!v || 'Please input Hotel',
        ],
        checkinRules: [
          v => (v === 0) || !!v || 'Please input Checkin',
        ],
        checkoutRules: [
          v => (v === 0) || !!v || 'Please input Checkout',
        ],
        roomTypeRules: [
          v => (v === 0) || !!v || 'Please input RoomType',
        ],
      };
    },
    methods: {
      getHotelList() {
        const query = {
          limit: 1000,
        };
        api.getHotelList(query)
        .then((result) => {
          if (result.status === 200) {
            // NOTE: 호텔의 name과 id 필요
            this.hotelItems = result.data.map((obj) => {
              const newObj = {};
              newObj.id = obj.id;
              newObj.name = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getRoomtypeList() {
        console.log('getRoomtypeList', this.hotel);
        api.getRoomtypeList(this.hotel)
        .then((result) => {
          if (result.status === 200) {
            // NOTE: 호텔의 name과 id 필요
            this.roomtypeItems = result.data.map((obj) => {
              const newObj = {};
              newObj.id = obj.id;
              newObj.name = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      createBooking() {
        const params = {
          user_email: this.email,
          hotel_id: this.hotel,
          roomtype_id: this.roomtype,
          checkin_at: this.$moment(this.checkin_at).format('YYYYMMDD'),
          checkout_at: this.$moment(this.checkout_at).format('YYYYMMDD'),
        };
        api.createBooking(params)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
            bookingsEventBus.$emit('reloadList');
            this.closeDialog();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      /**
       * @description 전체 창 open, close
       */
      openDialog() {
        this.dialog = true;
      },
      closeDialog() {
        this.dialog = false;
        this.clearAllField();
      },
    },
    computed: {
      getHotelName: {
        get() {
          return this.hotel;
        },
        set(newValue) {
          this.hotel = newValue;
        },
      },
      getRoomtype: {
        get() {
          return this.roomtype;
        },
        set(newValue) {
          this.roomtype = newValue;
        },
      },
    },
    mounted() {
      bookingsEventBus.$on('openDialog', () => {
        console.info('openDialog');
        this.openDialog();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/bookings/CreateBooking.vue